import React from 'react';
import classNames from 'classnames';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { Bok } from 'lib/templates/Foundation.BOKF.model';
import RichTextA11yWrapper from 'helpers/RichTextA11yWrapper/RichTextA11yWrapper';

export type TitleCopyProps = Bok.BaseTypes.TitleCopy & {
  params: { Background: { Value: { value: string } } };
};

export const Default = (props: TitleCopyProps): JSX.Element => {
  const { fields, params } = props;

  if (!fields) {
    return <></>;
  }
  return (
    <section
      className={classNames(
        'component spacing-md',
        params?.Background?.Value?.value ?? 'container'
      )}
    >
      <div className="container-inner">
        <Text tag="h1" field={fields?.Title} />
        <RichTextA11yWrapper className="p2 rtaw" field={fields?.CopyText} />
      </div>
    </section>
  );
};
